import { render, staticRenderFns } from "./ShiftsPerSpecialtyReport.vue?vue&type=template&id=363a7d24&"
import script from "./ShiftsPerSpecialtyReport.vue?vue&type=script&lang=ts&"
export * from "./ShiftsPerSpecialtyReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports